import { Button, Card, Grid, Text, styled } from '@ltvco/refresh-lib/theme';

export const StyledCard = styled(Card)({
  backgroundColor: '#EDE7F6',
  borderRadius: '0.25rem',
  boxShadow: '0 0.25rem 0.25rem rgba(0, 0, 0, 0.25)',
  border: 'none',
  padding: 0,
  overflow: 'hidden',
  marginTop: '1rem',
  marginBottom: '1rem',
});

export const Headline = styled(Text)(({ theme }) => ({
  fontWeight: 700,
  fontSize: '1.25rem',
  lineHeight: 1.235,
  letterSpacing: '0.016rem',
  color: theme.palette.text.primary,
  marginBottom: '0.5rem',
}));

export const BodyText = styled(Text)(({ theme }) => ({
  fontSize: '1rem',
  lineHeight: 1.5,
  letterSpacing: '0.009rem',
  color: theme.palette.text.secondary,
  marginBottom: '1.25rem',
}));

export const CtaButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.text.primary,
  color: theme.palette.common.white,
  borderRadius: '6.25rem',
  minWidth: '11.875rem',
  paddingTop: '0.5rem',
  paddingBottom: '0.5rem',
  paddingLeft: '1.375rem',
  paddingRight: '1.375rem',
  fontSize: '0.9375rem',
  fontWeight: 600,
  letterSpacing: '0.029rem',
  textTransform: 'none',
  whiteSpace: 'nowrap',
  '&:hover': {
    backgroundColor: theme.palette.grey[700],
  },
}));

export const IllustrationGrid = styled(Grid)(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-end',
  justifyContent: 'center',
  position: 'relative',
  overflow: 'hidden',
  minHeight: '12.5rem',
  [theme.breakpoints.up('md')]: {
    minHeight: '14rem',
  },
}));

export const IllustrationImage = styled('img')({
  width: '100%',
  height: 'auto',
  objectFit: 'contain',
  objectPosition: 'bottom',
});
